/**
 * Validates if all required params are present in order to submit an API request.
 * This goes along with the usage of the `skipToken` parameter to conditionally
 * make API calls.
 * @param applySome defaulted to `false`. Set to `true` to check only for the presence of some params
 * @param args the list of values to check
 * @param allowPartialForEstimate defaulted to `false`. Set to `true` to allow partial params when estimate is being restored
 * @returns `true` if all params are truthy or if some of them are truthy when `applySome` is set to `true`
 * @link https://redux-toolkit.js.org/rtk-query/usage/conditional-fetching
 */
export const shouldFetchFn = ({
  applySome = false,
  allowPartialForEstimate = false,
  ...args
}: {
  applySome?: boolean;
  allowPartialForEstimate?: boolean;
  args: unknown[];
}) => {
  const hasAllParams = args.args.every(Boolean);
  const hasSomeParams = args.args.some(Boolean);

  if (applySome) {
    return hasSomeParams;
  }

  // If we allow partial params for estimate restoration, check if we have zipCode and store at minimum
  if (allowPartialForEstimate && !hasAllParams) {
    const [zipCode, store] = args.args;

    return Boolean(zipCode && store);
  }

  return hasAllParams;
};
